import { apiInstance } from '@crm/shared/api';
import { keysToCamel } from '@crm/shared/lib';

import { userApiRoutes } from './api-routes';

import type { TUserDataDTO } from '../model';
import type { TBaseResponseType } from '@crm/shared/model/BaseResponse.type';

export const userApi = {
    getUserData: async () => {
        const response = await apiInstance
            .get(userApiRoutes.getUserDataRoute())
            .json<TBaseResponseType<TUserDataDTO>>();

        return keysToCamel(response.data);
    },
};
